import React from "react";
import { Navigate } from "react-router-dom";

// Layout Types
import { DefaultLayout, LoginLayout, BlankLayout, IframeLayout } from "./layouts";

// Route Views
import Dashboard from "./views/Dashboard/index";
import Login from "./views/Login/index";
import Clients from "./views/Clients/index";
import EditClient from "./views/EditClient/index";
import EditClientIntegrations from "./views/EditClientIntegrations/index";
import EditUser from "./views/EditUser/index";
import Users from "./views/Users/index";
import Locations from "./views/Locations/index";
import EditLocation from "./views/EditLocation/index";
import Citations from "./views/Citations/index";
import Violators from "./views/Violators/index";
import PotentialViolations from "./views/Violations/index";
import Payments from "./views/Payments/index";
import Citation from "./views/Citation/index";
import ForgotPassword from "./views/ForgotPassword/index";
import PermittedVehicles from "./views/PermittedVehicles/index";
import Warnings from "./views/Warnings/index";
import Zones from "./views/Zones/index";
import Tenants from "./views/Tenants/index";
import TenantVehicles from "./views/TenantVehicles/index";
import Activity from "./views/Activity/index";
import Checkins from "./views/Checkins/index";
import CallbackLoading from "./views/CallbackLoading/index";
import DisputeCenter from "./views/DisputeCenter/index";
import DisputeAssistantRequest from "./views/DisputeCenter/DisputeAssistantRequest";
import StripePayments from "./views/StripePayments/index";
import CitationsEmbed from "./views/CitationsEmbed/index";
import ViolationsEmbed from "./views/ViolationsEmbed/index";
import PaymentsEmbed from "./views/PaymentsEmbed/index";
import WarningsEmbed from "./views/WarningsEmbed/index";

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Navigate to="/dashboard" />
  },
  {
    path: "/login",
    exact: true,
    layout: LoginLayout,
    component: Login
  },
  {
    path: "/forgot-password",
    exact: true,
    layout: LoginLayout,
    component: ForgotPassword
  },
  {
    path: "/dashboard",
    layout: DefaultLayout,
    component: Dashboard
  },
  {
    path: "/clients",
    layout: DefaultLayout,
    component: Clients
  },
  {
    path: "/add-client",
    layout: DefaultLayout,
    component: EditClient
  },
  {
    path: "/edit-client/:clientId",
    layout: DefaultLayout,
    component: EditClient
  },
  {
    path: "/edit-client-integrations/:clientId",
    layout: DefaultLayout,
    component: EditClientIntegrations
  },
  {
    path: "/users",
    layout: DefaultLayout,
    component: Users
  },
  {
    path: "/add-user",
    layout: DefaultLayout,
    component: EditUser
  },
  {
    path: "/edit-user/:userId",
    layout: DefaultLayout,
    component: EditUser
  },
  {
    path: "/locations",
    layout: DefaultLayout,
    component: Locations
  },
  {
    path: "/add-location",
    layout: DefaultLayout,
    component: EditLocation
  },
  {
    path: "/edit-location/:locationId",
    layout: DefaultLayout,
    component: EditLocation
  },
  {
    path: "/location/:locationId/zones",
    layout: DefaultLayout,
    component: Zones
  },
  {
    path: "/location/:locationId/payments-stripe",
    layout: DefaultLayout,
    component: StripePayments
  },
  {
    path: "/payments-stripe",
    layout: DefaultLayout,
    component: StripePayments
  },
  {
    path: "/permitted-vehicles/:locationId",
    layout: DefaultLayout,
    component: PermittedVehicles
  },
  {
    path: "/citations",
    layout: DefaultLayout,
    component: Citations
  },
  {
    path: "/violators",
    layout: DefaultLayout,
    component: Violators
  },
  {
    path: "/violations",
    layout: DefaultLayout,
    component: PotentialViolations
  },
  {
    path: "/citation/:violationNumber",
    layout: DefaultLayout,
    component: Citation
  },
  {
    path: "/payments",
    layout: DefaultLayout,
    component: Payments
  },
  {
    path: "/warnings",
    layout: DefaultLayout,
    component: Warnings
  },
  {
    path: "/location/:locationId/tenants",
    layout: DefaultLayout,
    component: Tenants
  },
  {
    path: "/tenant-vehicles",
    layout: DefaultLayout,
    component: TenantVehicles
  },
  {
    path: "/activities",
    layout: DefaultLayout,
    component: Activity
  },
  {
    path: "/checkins",
    layout: DefaultLayout,
    component: Checkins
  },
  {
    path: "/dispute-center",
    layout: DefaultLayout,
    component: DisputeCenter
  },
  {
    path: "/dispute-assistant-request",
    layout: DefaultLayout,
    component: DisputeAssistantRequest
  },
  {
    path: "/callback",
    layout: DefaultLayout,
    component: CallbackLoading
  },
  {
    path: "/embed/citations",
    layout: IframeLayout,
    component: CitationsEmbed
  },
  {
    path: "/embed/violations",
    layout: IframeLayout,
    component: ViolationsEmbed
  },
  {
    path: "/embed/payments",
    layout: IframeLayout,
    component: PaymentsEmbed
  },
  {
    path: "/embed/warnings",
    layout: IframeLayout,
    component: WarningsEmbed
  }
];
